import { render, staticRenderFns } from "./AnexosList.vue?vue&type=template&id=810fb60e"
import script from "./AnexosList.vue?vue&type=script&lang=js"
export * from "./AnexosList.vue?vue&type=script&lang=js"
import style0 from "./AnexosList.vue?vue&type=style&index=0&id=810fb60e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports